import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  label: string;
  variant: string;
}

const Chip = ({ label, variant }: Props) => {
  return <StyledChip variant={variant}>{label}</StyledChip>;
};

interface ChipStatusProps {
  variant: string;
}

const StyledChip = styled.div<ChipStatusProps>`
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
  background: ${(props) =>
    props.variant === "success" ? Colors.mainGreen : Colors.hippy};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  color: ${Colors.white};
  font-family: Poppins-Medium;
  width: 5.1rem;
`;

export default Chip;
